<template>
  <div layout:fragment="content">
    <h1>Error Page</h1>
    <button @click="callErrorApi()">List up</button>

    error code :
    <span th:text="${code}"></span>
    <br />error msg :
    <span th:text="${msg}"></span>
    <br />timestamp :
    <span th:text="${timestamp}"></span>
  </div>
</template>

<script>
export default {
  name: "error",
  props: {
    code: String,
    msg: String,
    timestamp: Date,
  },
};
</script>
